/**
 * Parts and Hardware — Return Request form
 * Posts multipart case to NetSuite external form.
 */
(function () {
  'use strict';

  var $j = null;
  var formLoadTime = Date.now();
  var awaitingIframeSubmit = false;
  var lastFocusedBeforeModal = null;

  var CUSTOMER_FAULT = ['ordered_wrong_part', 'bought_by_mistake', 'ordered_too_many', 'does_not_fit'];
  var COMPANY_FAULT = ['sent_wrong_item', 'missing_parts', 'item_damaged', 'not_like_picture', 'other'];

  var REASON_LABELS = {
    ordered_wrong_part: 'Ordered wrong part',
    bought_by_mistake: 'Bought by mistake',
    ordered_too_many: 'Ordered too many',
    sent_wrong_item: 'I was sent the wrong item',
    missing_parts: 'Missing parts',
    item_damaged: 'Item damaged',
    does_not_fit: 'The item does not fit',
    not_like_picture: "Doesn't match picture",
    other: 'Other'
  };

  var AUTO_DETAILS = {
    ordered_wrong_part: 'Customer ordered the wrong part',
    bought_by_mistake: 'Customer bought by mistake',
    ordered_too_many: 'Customer ordered too many items',
    sent_wrong_item: 'Customer was sent the wrong item',
    missing_parts: 'Missing parts in order',
    item_damaged: 'Item arrived damaged',
    does_not_fit: 'Item does not fit as expected',
    not_like_picture: 'Item does not match the picture',
    other: 'Other reason for return'
  };

  function sanitizeText(input) {
    if (typeof input !== 'string') return '';
    return input
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;')
      .trim();
  }

  function sanitizeFileName(fileName) {
    if (typeof fileName !== 'string') return 'unknown_file';
    return fileName
      .replace(/[<>:"/\\|?*]/g, '_')
      .replace(/\.\./g, '_')
      .replace(/^\./, '_')
      .substring(0, 100)
      .trim();
  }

  function createSafeTextNode(text) {
    return document.createTextNode(sanitizeText(text));
  }

  function isHeicFile(file) {
    if (!file) return false;
    var name = String(file.name || '').toLowerCase();
    var type = String(file.type || '').toLowerCase();
    return /\.(heic|heif)$/.test(name) || type === 'image/heic' || type === 'image/heif';
  }

  function validateFileType(file) {
    var allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    var allowedExtensions = ['.jpg', '.jpeg', '.png'];
    if (allowedTypes.indexOf(file.type) === -1) return false;
    var fileName = String(file.name || '').toLowerCase();
    var okExt = allowedExtensions.some(function (ext) {
      return fileName.endsWith(ext);
    });
    return okExt && file.size <= 10 * 1024 * 1024;
  }

  function compressImage(file, maxWidth, maxHeight, quality) {
    maxWidth = maxWidth || 1200;
    maxHeight = maxHeight || 900;
    quality = quality || 0.75;
    return new Promise(function (resolve) {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var img = new Image();
      var objectUrl = URL.createObjectURL(file);
      function useOriginal() {
        URL.revokeObjectURL(objectUrl);
        resolve(file);
      }
      img.onload = function () {
        try {
          if (!ctx) return useOriginal();
          var width = img.width;
          var height = img.height;
          if (width > height) {
            if (width > maxWidth) {
              height = (height * maxWidth) / width;
              width = maxWidth;
            }
          } else if (height > maxHeight) {
            width = (width * maxHeight) / height;
            height = maxHeight;
          }
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          canvas.toBlob(
            function (blob) {
              if (blob) {
                URL.revokeObjectURL(objectUrl);
                resolve(blob);
              } else {
                useOriginal();
              }
            },
            'image/jpeg',
            quality
          );
        } catch (e) {
          useOriginal();
        }
      };
      img.onerror = useOriginal;
      img.src = objectUrl;
    });
  }

  function setHidden(el, hide) {
    if (!el) return;
    if (hide) {
      el.hidden = true;
      el.setAttribute('hidden', '');
    } else {
      el.hidden = false;
      el.removeAttribute('hidden');
    }
  }

  function selectedReturnReason() {
    var el = document.querySelector('#phk-return-form input[name="return_reason"]:checked');
    return el ? el.value : '';
  }

  function clearContactFields() {
    ['firstname', 'lastname', 'email', 'phone', 'order_id', 'part_numbers_returning'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.value = '';
    });
    document.querySelectorAll('#rr-contact-section input[type="radio"]').forEach(function (r) {
      r.checked = false;
    });
    document.querySelectorAll('#rr-contact-section .phk-rr__radio').forEach(function (opt) {
      opt.classList.remove('is-selected');
    });
    setHidden(document.getElementById('rr-part-numbers-section'), true);
  }

  function clearAllImages() {
    for (var i = 1; i <= 4; i++) window.clearSingleImage(i);
  }

  function toggleSections(returnReason) {
    var contact = document.getElementById('rr-contact-section');
    var details = document.getElementById('rr-details-section');
    var photos = document.getElementById('rr-photo-section');
    var showContact =
      CUSTOMER_FAULT.indexOf(returnReason) !== -1 || COMPANY_FAULT.indexOf(returnReason) !== -1;
    var isCompany = COMPANY_FAULT.indexOf(returnReason) !== -1;
    var isCustomer = CUSTOMER_FAULT.indexOf(returnReason) !== -1;

    setHidden(contact, !showContact);
    setHidden(details, !isCompany);
    setHidden(photos, !isCompany);

    if (isCustomer) {
      var desc = document.getElementById('user_description');
      if (desc) desc.value = '';
      clearAllImages();
    }
    if (!showContact) clearContactFields();
    updateIncomingMessage();
  }

  function togglePartNumbers(entireOrderValue) {
    var section = document.getElementById('rr-part-numbers-section');
    var field = document.getElementById('part_numbers_returning');
    var show = entireOrderValue === 'no';
    setHidden(section, !show);
    if (!show && field) field.value = '';
  }

  function updateIncomingMessage() {
    var orderID = sanitizeText((document.getElementById('order_id') || {}).value || '');
    var entireEl = document.querySelector('#phk-return-form input[name="entire_order"]:checked');
    var entireOrder = entireEl ? sanitizeText(entireEl.value) : '';
    var partNumbers = sanitizeText((document.getElementById('part_numbers_returning') || {}).value || '');
    var returnReason = sanitizeText(selectedReturnReason());
    var userDetails = sanitizeText((document.getElementById('user_description') || {}).value || '');

    var imageCount = 0;
    for (var i = 1; i <= 4; i++) {
      var fileInput = document.getElementById('file' + i);
      if (fileInput && fileInput.files && fileInput.files.length) imageCount++;
    }

    var details = ['RETURN REQUEST DETAILS', '======================', ''];
    if (orderID) details.push('Order ID: ' + orderID);
    if (entireOrder) details.push('Returning Entire Order: ' + (entireOrder === 'yes' ? 'Yes' : 'No'));
    if (partNumbers) details.push('Part Numbers Returning: ' + partNumbers);
    if (returnReason) details.push('Reason for Return: ' + (REASON_LABELS[returnReason] || returnReason));

    var returnDetails = userDetails;
    if ((!returnDetails || !returnDetails.trim()) && returnReason) {
      returnDetails = AUTO_DETAILS[returnReason] || 'Return requested';
    }
    if (returnDetails && returnDetails.trim()) {
      details.push('');
      details.push('RETURN DETAILS:');
      details.push(returnDetails);
    }
    if (imageCount > 0) {
      details.push('');
      details.push('Photos Uploaded: ' + imageCount);
    }
    details.push('');
    details.push('Generated by Parts and Hardware Return Request Form');

    var messageField = document.getElementById('incomingmessage');
    if (messageField) messageField.value = details.join('\n');

    var titleField = document.querySelector('#phk-return-form input[name="title"]');
    if (titleField) {
      titleField.value =
        COMPANY_FAULT.indexOf(returnReason) !== -1
          ? 'Return Request - High Priority - PAHW'
          : 'Return Request - PAHW';
    }
  }

  window.updateSingleImage = function (input, containerNum) {
    var fileNameDiv = document.getElementById('file-name-' + containerNum);
    var imagePreview = document.getElementById('image-preview-' + containerNum);
    var uploadContent = document.getElementById('upload-content-' + containerNum);
    var imageContainer = document.getElementById('image-container-' + containerNum);
    if (!fileNameDiv || !imagePreview || !uploadContent || !imageContainer) return;

    while (imageContainer.firstChild) imageContainer.removeChild(imageContainer.firstChild);
    fileNameDiv.textContent = '';
    fileNameDiv.classList.remove('is-ok', 'is-error');

    if (!(input.files && input.files.length)) {
      uploadContent.style.display = 'flex';
      imagePreview.classList.remove('is-visible');
      return;
    }

    var file = input.files[0];
    if (isHeicFile(file)) {
      fileNameDiv.textContent = 'Unsupported iPhone photo. Please upload JPG or PNG.';
      fileNameDiv.classList.add('is-error');
      input.value = '';
      return;
    }
    if (!validateFileType(file)) {
      fileNameDiv.textContent = 'Invalid file or too large (max 10MB). JPG/PNG only.';
      fileNameDiv.classList.add('is-error');
      input.value = '';
      return;
    }

    fileNameDiv.textContent = 'Compressing…';
    compressImage(file).then(function (compressedBlob) {
      var firstName = ((document.getElementById('firstname') || {}).value || 'customer').trim() || 'customer';
      var lastName = ((document.getElementById('lastname') || {}).value || 'return').trim() || 'return';
      var now = new Date();
      var timestamp =
        String(now.getMonth() + 1).padStart(2, '0') +
        String(now.getDate()).padStart(2, '0') +
        String(now.getFullYear()).slice(-2) +
        '_' +
        String(now.getMinutes()).padStart(2, '0') +
        String(now.getSeconds()).padStart(2, '0');
      var newFileName = firstName + '_' + lastName + '_RR_' + timestamp + '.jpg';
      var submittedFile = file;
      var submittedFileName = file.name;
      try {
        if (typeof File === 'function' && typeof DataTransfer === 'function') {
          var compressedFile = new File([compressedBlob], newFileName, {
            type: 'image/jpeg',
            lastModified: Date.now()
          });
          var dt = new DataTransfer();
          dt.items.add(compressedFile);
          input.files = dt.files;
          submittedFile = compressedFile;
          submittedFileName = newFileName;
        }
      } catch (e) {
        /* keep original */
      }

      fileNameDiv.textContent =
        'Selected: ' +
        sanitizeFileName(submittedFileName) +
        ' (' +
        (submittedFile.size / 1024 / 1024).toFixed(2) +
        'MB)';
      fileNameDiv.classList.add('is-ok');

      var reader = new FileReader();
      reader.onload = function (e) {
        var img = document.createElement('img');
        img.src = e.target.result;
        img.alt = 'Preview ' + containerNum;
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'phk-pi__remove';
        removeBtn.setAttribute('aria-label', 'Remove photo');
        removeBtn.appendChild(createSafeTextNode('×'));
        removeBtn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          window.clearSingleImage(containerNum);
        });
        imageContainer.appendChild(img);
        imageContainer.appendChild(removeBtn);
        uploadContent.style.display = 'none';
        imagePreview.classList.add('is-visible');
        updateIncomingMessage();
      };
      reader.readAsDataURL(compressedBlob);
    });
  };

  window.clearSingleImage = function (containerNum) {
    var fileInput = document.getElementById('file' + containerNum);
    var fileNameDiv = document.getElementById('file-name-' + containerNum);
    var imagePreview = document.getElementById('image-preview-' + containerNum);
    var uploadContent = document.getElementById('upload-content-' + containerNum);
    var imageContainer = document.getElementById('image-container-' + containerNum);
    if (fileInput) fileInput.value = '';
    if (fileNameDiv) {
      fileNameDiv.textContent = '';
      fileNameDiv.classList.remove('is-ok', 'is-error');
    }
    if (imageContainer) while (imageContainer.firstChild) imageContainer.removeChild(imageContainer.firstChild);
    if (imagePreview) imagePreview.classList.remove('is-visible');
    if (uploadContent) uploadContent.style.display = 'flex';
    updateIncomingMessage();
  };

  function resetSubmitButton(submitBtn) {
    if (!submitBtn || !submitBtn.length) submitBtn = $j('#submitter');
    submitBtn.prop('disabled', false).removeClass('is-loading loading');
    submitBtn.text('Submit Return Request');
  }

  function getSuccessModal() {
    return document.getElementById('phk-rr-success-modal');
  }

  function showSuccessModal() {
    var modal = getSuccessModal();
    if (!modal) return;
    lastFocusedBeforeModal = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('phk-pi-modal-open');
    var primary = modal.querySelector('.phk-pi-modal__btn--primary');
    if (primary) primary.focus();
  }

  function hideSuccessModal() {
    var modal = getSuccessModal();
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('phk-pi-modal-open');
    if (lastFocusedBeforeModal && typeof lastFocusedBeforeModal.focus === 'function') {
      lastFocusedBeforeModal.focus();
    }
  }

  function bindSuccessModal() {
    var modal = getSuccessModal();
    if (!modal || modal.__phkBound) return;
    modal.__phkBound = true;
    modal.querySelectorAll('[data-phk-rr-modal-close]').forEach(function (el) {
      el.addEventListener('click', hideSuccessModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) hideSuccessModal();
    });
  }

  function resetConditionalSections() {
    setHidden(document.getElementById('rr-contact-section'), true);
    setHidden(document.getElementById('rr-details-section'), true);
    setHidden(document.getElementById('rr-photo-section'), true);
    setHidden(document.getElementById('rr-part-numbers-section'), true);
    document.querySelectorAll('#phk-return-form .phk-rr__radio').forEach(function (opt) {
      opt.classList.remove('is-selected');
    });
  }

  function bindSubmitIframe(form) {
    var iframe = document.getElementById('server_commands');
    if (!iframe || iframe.__phkBound) return;
    iframe.__phkBound = true;
    iframe.addEventListener('load', function () {
      if (!awaitingIframeSubmit) return;
      awaitingIframeSubmit = false;
      try {
        form.reset();
        clearAllImages();
        resetConditionalSections();
      } catch (e) {
        /* ignore */
      }
      resetSubmitButton($j('#submitter'));
      showSuccessModal();
    });
  }

  function submitViaIframe(form, submitBtn) {
    var iframe = document.getElementById('server_commands');
    if (!iframe) {
      // Stay on this site — never full-page navigate to NetSuite/AADW thank-you.
      showSuccessModal();
      return;
    }
    form.setAttribute('target', 'server_commands');
    awaitingIframeSubmit = true;
    if (submitBtn && submitBtn.length) {
      submitBtn.text('Submitting…').prop('disabled', true).addClass('is-loading');
    }
    // Safety net if iframe load is blocked; still keep the shopper on PHK.
    setTimeout(function () {
      if (!awaitingIframeSubmit) return;
      awaitingIframeSubmit = false;
      try {
        form.reset();
        clearAllImages();
        resetConditionalSections();
      } catch (e) {
        /* ignore */
      }
      resetSubmitButton(submitBtn);
      showSuccessModal();
    }, 4500);
    try {
      form.submit();
    } catch (e) {
      awaitingIframeSubmit = false;
      resetSubmitButton(submitBtn);
      showSuccessModal();
    }
  }

  function initPhotoAreas() {
    for (var i = 1; i <= 4; i++) {
      (function (n) {
        var area = document.getElementById('upload-area-' + n);
        var input = document.getElementById('file' + n);
        var content = document.getElementById('upload-content-' + n);
        if (!area || !input || !content || area.__phkBound) return;
        area.__phkBound = true;
        area.addEventListener('click', function (e) {
          if (e.target === area || e.target === content || content.contains(e.target)) input.click();
        });
        area.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            input.click();
          }
        });
        ['dragenter', 'dragover'].forEach(function (evt) {
          area.addEventListener(evt, function (e) {
            e.preventDefault();
            area.classList.add('is-dragover');
          });
        });
        ['dragleave', 'drop'].forEach(function (evt) {
          area.addEventListener(evt, function (e) {
            e.preventDefault();
            area.classList.remove('is-dragover');
          });
        });
        area.addEventListener('drop', function (e) {
          e.preventDefault();
          if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
            input.files = e.dataTransfer.files;
            window.updateSingleImage(input, n);
          }
        });
      })(i);
    }
  }

  function syncRadioSelected(radio) {
    if (!radio || !radio.name) return;
    document.querySelectorAll('#phk-return-form input[name="' + radio.name + '"]').forEach(function (r) {
      var opt = r.closest('.phk-rr__radio');
      if (opt) opt.classList.toggle('is-selected', r.checked);
    });
  }

  function initializeForm() {
    if (typeof window.jQuery !== 'function') {
      console.error('[PHK Return Form] jQuery missing');
      return;
    }
    $j = window.jQuery;
    var form = document.getElementById('phk-return-form');
    if (!form) return;
    if (form.__phkInitialized && $j(form).data('validator')) return;
    form.__phkInitialized = true;

    var messageField = document.getElementById('incomingmessage');
    if (messageField) messageField.value = 'Return request form initialized';
    updateIncomingMessage();
    initPhotoAreas();
    bindSuccessModal();
    bindSubmitIframe(form);

    $j('#phk-return-form').on('change', 'input[type="radio"]', function () {
      syncRadioSelected(this);
      if (this.name === 'return_reason') toggleSections(this.value);
      if (this.name === 'entire_order') togglePartNumbers(this.value);
      updateIncomingMessage();
    });

    $j('#phk-return-form').on('input change', 'input, textarea, select', function () {
      clearTimeout(window.__phkRrMsgTimer);
      window.__phkRrMsgTimer = setTimeout(updateIncomingMessage, 250);
    });

    // Always keep submit on-site via iframe + success modal (never navigate to NetSuite/AADW).
    form.addEventListener(
      'submit',
      function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (awaitingIframeSubmit) return;
        var hp = document.getElementById('rr_hp_url');
        if (hp && hp.value) return;
        if (Date.now() - formLoadTime < 2500) return;
        var validator = $j(form).data('validator');
        if (validator && !$j(form).valid()) return;
        updateIncomingMessage();
        var mf = document.getElementById('incomingmessage');
        if (mf && !mf.value.trim()) mf.value = 'Return request submitted';
        var submitBtn = $j('#submitter');
        if (submitBtn.prop('disabled')) return;
        submitViaIframe(form, submitBtn);
      },
      true
    );

    if (!($j.validator && typeof $j.fn.validate === 'function')) {
      console.warn('[PHK Return Form] jquery.validate missing - using native required + iframe submit');
      return;
    }

    $j.validator.addMethod(
      'tc_emailDomainCheck',
      function (value, element) {
        return (
          this.optional(element) ||
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
        );
      },
      'Please enter a valid email address.'
    );

    $j.validator.addMethod(
      'tc_phoneUS',
      function (phone_number, element) {
        phone_number = phone_number.replace(/[\s.\-()+]/g, '');
        if (phone_number.length === 11 && phone_number.charAt(0) === '1') {
          phone_number = phone_number.substring(1);
        }
        return this.optional(element) || (phone_number.length === 10 && /^[2-9]\d{2}[2-9]\d{6}$/.test(phone_number));
      },
      'Please enter a valid US phone number (e.g. 555-867-5309)'
    );

    $j.validator.addMethod(
      'requiredIfVisible',
      function (value, element) {
        var $element = $j(element);
        var $container;
        if ($element.attr('name') === 'return_reason') {
          return $j('input[name="return_reason"]:checked').length > 0;
        }
        if ($element.attr('name') === 'entire_order') {
          $container = $j('#rr-contact-section');
          if (!$container.length || $container.is('[hidden]') || !$container.is(':visible')) return true;
          return $j('input[name="entire_order"]:checked').length > 0;
        }
        if ($element.attr('type') === 'file') {
          $container = $j('#rr-photo-section');
        } else if ($element.attr('id') === 'user_description') {
          $container = $j('#rr-details-section');
        } else if ($element.attr('id') === 'part_numbers_returning') {
          $container = $j('#rr-part-numbers-section');
        } else {
          $container = $j('#rr-contact-section');
        }
        if (!$container.length || $container.is('[hidden]') || !$container.is(':visible')) return true;
        if ($element.attr('type') === 'file') {
          return element.files && element.files.length > 0;
        }
        return value && String(value).trim().length > 0;
      },
      'This field is required'
    );

    $j('#phk-return-form').validate({
      ignore: '',
      rules: {
        return_reason: { required: true },
        firstname: { requiredIfVisible: true, minlength: 2, maxlength: 40 },
        lastname: { requiredIfVisible: true, minlength: 2, maxlength: 40 },
        phone: { requiredIfVisible: true, tc_phoneUS: true },
        email: { requiredIfVisible: true, tc_emailDomainCheck: true },
        order_id: { requiredIfVisible: true, minlength: 3 },
        entire_order: { requiredIfVisible: true },
        part_numbers_returning: { requiredIfVisible: true, minlength: 2 },
        user_description: {
          requiredIfVisible: true,
          minlength: function () {
            var section = document.getElementById('rr-details-section');
            return section && !section.hidden ? 10 : false;
          }
        },
        file1: { requiredIfVisible: true },
        file2: { requiredIfVisible: true },
        file3: { required: false },
        file4: { required: false }
      },
      messages: {
        return_reason: { required: 'Please select a reason for your return' },
        firstname: { requiredIfVisible: 'Please enter your first name' },
        lastname: { requiredIfVisible: 'Please enter your last name' },
        email: { requiredIfVisible: 'Please enter your email address' },
        phone: { requiredIfVisible: 'Please enter your phone number' },
        order_id: { requiredIfVisible: 'Please enter your order ID' },
        entire_order: { requiredIfVisible: 'Please select whether you are returning the entire order' },
        part_numbers_returning: { requiredIfVisible: 'Please enter the part numbers you are returning' },
        user_description: {
          requiredIfVisible: 'Please describe your return request in detail',
          minlength: 'Please provide more details (at least 10 characters)'
        },
        file1: { requiredIfVisible: 'Please upload the first photo of your item' },
        file2: { requiredIfVisible: 'Please upload the second photo of your item' }
      },
      errorPlacement: function (error, element) {
        error.addClass('error');
        if (element.attr('type') === 'radio') {
          var grid = element.closest('.phk-rr__reason-grid, .phk-rr__radio-grid');
          if (grid.length) error.insertAfter(grid);
          else error.insertAfter(element.closest('.phk-pi__field'));
        } else if (element.attr('type') === 'file') {
          var n = element.attr('id').replace('file', '');
          var fileNameDiv = document.getElementById('file-name-' + n);
          if (fileNameDiv) error.insertAfter(fileNameDiv);
          else error.insertAfter(element.closest('.phk-pi__upload'));
        } else {
          error.insertAfter(element);
        }
      },
      focusInvalid: false,
      submitHandler: function (formEl) {
        // Capture-phase listener already handles iframe submit + success modal.
        return false;
      },
      invalidHandler: function () {
        resetSubmitButton($j('#submitter'));
      }
    });
  }

  function boot() {
    initPhotoAreas();
    if (typeof window.jQuery === 'function') {
      if (window.jQuery.fn && window.jQuery.fn.validate) initializeForm();
      else {
        var tries = 0;
        var t = setInterval(function () {
          tries++;
          if (window.jQuery && window.jQuery.fn && window.jQuery.fn.validate) {
            clearInterval(t);
            initializeForm();
          } else if (tries > 40) {
            clearInterval(t);
            initializeForm();
          }
        }, 100);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
